import styled from 'styled-components';

export const InningRuleToggle = styled.div`
  display: flex;
`;

export const Label = styled.div`
  font-family: Lato;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0.5px;
  margin-right: 10px;
  margin-top: 2px;
`;
